import { AddProductMenuWebComponent } from './component/AddProductMenuWebComponent';
import { WEB_COMPONENT_ADD_PRODUCT_MENU } from '../../../webcomponents.constants';

export { AddProductMenuWebComponent };

window.customElements.define(WEB_COMPONENT_ADD_PRODUCT_MENU, AddProductMenuWebComponent);
